// extracted by mini-css-extract-plugin
export default {"loading":"goodsDetail_loading__YEglj","h5Wrap":"goodsDetail_h5Wrap__nTD-Y"};